export function addEvent(){
    var elem = arguments[0];
    let event = arguments[1];

    let callback = null;
    let childSelector = null;

    var callbackOrChildSelector = arguments[2];
    if(typeof callbackOrChildSelector === 'string'){
        childSelector = callbackOrChildSelector;
        callback = arguments[3];
    }
    else{
        childSelector = null;
        callback = arguments[2];
    }

    elem.addEventListener(event, e => {
        if(childSelector){
            let target = e.target.closest(childSelector);
            if(!target || !elem.contains(target)) return;
            callback.call(this, e, target);
            return;
        }
        
        callback.call(this, e);
    });
}

export function xmlToString(xml) {
    if (!isXML(xml)) return null;
    return new XMLSerializer().serializeToString(xml);
}

export function parseXML(xmlString) {
    if(isXML(xmlString)) return xmlString;

    let parser = new DOMParser();
    let xmlDoc = parser.parseFromString(xmlString, "text/xml");
    if(xmlDoc.getElementsByTagName('parseerror').length > 0) return null;

    return xmlDoc;
}

export function isXML(value) {
    return value instanceof XMLDocument || isElement(value);
}

export function isElement(value) {
    return value instanceof Element || value instanceof Node;
}

export function scrollTop(){
    let arg = arguments[0];
    let value = null;
    let elem = null;

    if(isElement(arg)) {
        elem = arg;
        value = arguments[1];
    }
    else if(typeof arg === 'number' || arg === undefined) {
        elem = document.documentElement;
        value = arg;
    }

    if(elem === document.documentElement){
        if(value !== undefined) {
            document.documentElement.scrollTop = value;
            document.body.scrollTop = value;
        }
        else value = document.documentElement.scrollTop || document.body.scrollTop;
    }
    else if(isElement(elem)){
        if(value !== undefined) elem.scrollTop = value;
        else value = elem.scrollTop;
    }

    return elem === document.documentElement ? (document.documentElement.scrollTop || document.body.scrollTop) : elem.scrollTop;
}

export function wrapElement(element, wrapper) {
    if (!isElement(element) || !isElement(wrapper)) return null;

    let parent = element.parentNode;
    if (parent) {
        parent.insertBefore(wrapper, element);
        wrapper.appendChild(element);
    }

    return wrapper;

}